<template>
  <div class="acc-report">
    <div class="acc-report-col">
      <ReportList full-height
                  :type="reportType"></ReportList>
    </div>
    <div class="acc-report-recipient-col pa-4">
      <ReportRecipientInput :type="reportType"></ReportRecipientInput>
    </div>
  </div>
</template>

<script>
import ReportRecipientInput from "@/components/report/ReportRecipientInput.vue";
import ReportList from "@/components/report/ReportList.vue";

export default {
  name: 'AccReport',
  props: {
    reportType: String,
  },
  components: {ReportList, ReportRecipientInput},
}
</script>

<style lang="less">
.acc-report {
  width: 100%;
  height: 60vh;

  display: flex;

  .acc-report-col {
    flex: 1 1 0;
  }

  .acc-report-recipient-col {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
  }
}
</style>
